<template>
    <header class="wc-kit__active-header">
        <h1>Kit Builder</h1>
        <div>
            <h2 class="kit-subtitle">{{ $store.state.step + 1 }}. Please select a {{  singular() }}</h2>

            <button class="kit-skip" @click="$store.dispatch('next')">Skip this step</button>
        </div>
    </header>

    <ul class="kit-products">
        <li v-for="(product, key) in products" :key="key">
            <Product :p-data="product" />
        </li>
    </ul>
</template>

<script>
    import Product from '../components/Product.vue';

    export default {
        name: 'List',
        data() {
            return {
                products: []
            }
        },
        components: {
            Product
        },
        watch: {
            '$store.state.step': function () {
                this.updateProducts();
            }
        },
        methods: {
            singular() {

                if (!this.$store.state.step) return '';

                return this.$store.state.current.groups[this.$store.state.step - 1].singular;
            },

            updateProducts() {
                if (!this.$store.state.step) this.products = [];

                if (typeof this.$store.state.current.groups[this.$store.state.step - 1] === 'undefined') {
                    this.products = [];

                    return;
                }

                this.products = this.$store.state.current.groups[this.$store.state.step - 1].products;
            }
        },

        mounted() {
            this.updateProducts();
        }
    }
</script>

<style lang="scss">
    .kit {
        &-skip {
            color: #F97623;
            font-weight: 600;
            line-height: 23px;
            text-decoration-line: underline;
        }

        &-products {
            display: grid;
            grid-template-columns: repeat(4, minmax(0, 1fr));
            gap: 10px;

            @media (max-width: 1024px) {
                grid-template-columns: repeat(2, minmax(0, 1fr));
            }

            @media (max-width: 992px) {
                grid-template-columns: repeat(4, minmax(0, 1fr));
            }

            @media (max-width: 576px) {
                grid-template-columns: repeat(2, minmax(0, 1fr));
            }
        }
    }
</style>